export default "<h2 class=\"addEdit-title \">{{title}}</h2> \r\n";